/*
 * One-Minute Maths
 * Copyright © 2021 White Rose Maths
 * HundredSquare.tsx - Ten Frame layout.
*/

import React from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import HundredSquareElement from './HundredSquareElement';

const NUMBER_ELEMENTS = 10;

interface HundredSquareProps {
  numA: number;
  usableWidth: number;
  usableHeight: number;
}
  
const HundredSquareNew = ({ numA, usableWidth, usableHeight }: HundredSquareProps) => {

  // A hundred Square is a 10 by 10 array showing a number
  // represented by highlighted squares within the array.
  // Calculate the size of the array element by finding the smallest
  // ratio between screen width and number of columns or screen height and number of rows.
  const elementHeight = Math.floor(usableHeight / NUMBER_ELEMENTS);
  const elementWidth = Math.floor(usableWidth / NUMBER_ELEMENTS);
  const elementSize = Math.min(elementHeight, elementWidth);

  let row = [];
  const cols = [];

  const numRows = 10;
  const numCols = 10;

  for (let i = 0; i < numRows; i++) {
    for (let j = 0; j < numCols; j++) {
      const elementNum = (i + 1) * (j + 1);
      const right = j === 9;
      const bottom = i === 9;
      if (numA > 0) {
        numA -= 1;
        row.push(
          <HundredSquareElement key={`element${elementNum}`} width={elementSize} height={elementSize} color="yellow" bottom={bottom} right={right} />
        );
      } else {
        row.push(
          <HundredSquareElement key={`element${elementNum}`} width={elementSize} height={elementSize} color="white" bottom={bottom} right={right} />
        );
      }
    }
    cols.push(
      <View key={`hundredSquare${i}`} style={styles.arrayRow}>
        {row}
      </View>
    );
    row = [];
  }

  return (
    <View style={styles.array}>
      {cols}
    </View>
  );
};

export default HundredSquareNew;
  
const styles = StyleSheet.create({
  array: {
    flexDirection: 'column',
    left: 0,
    margin: 0,
    justifyContent: 'center',
    alignContent: 'center',
  },

  arrayRow: {
    flexDirection: 'row'
  }

});
